module.exports = __webpack_public_path__ + "img/logo_jlab.f4e39442.jpg";